import { render, staticRenderFns } from "./HemophiliaProductsUse.vue?vue&type=template&id=05342fd0"
import script from "./HemophiliaProductsUse.vue?vue&type=script&lang=ts"
export * from "./HemophiliaProductsUse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports